if (!customElements.get('added-notification')) {
  const AddedNotification = class extends HTMLElement {
    connectedCallback() {
      // Instead of showing a notification, open the cart drawer directly
      document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:open', {
        detail: { opener: this }
      }));

      // Optional: remove the element (cleanup)
      this.remove();
    }
  };

  window.customElements.define('added-notification', AddedNotification);
}
